import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ArrowRight } from 'lucide-react';
import { trackAndRedirect } from '../utils/metaPixel';
export function BonusSection() {
  return <section className="py-12 px-4 bg-cream text-text-body overflow-hidden" data-id="element-17">
      <div className="max-w-5xl mx-auto" data-id="element-18">
        {/* Section Header */}
        <FadeIn data-id="element-19">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-20">
            <span className="inline-block py-1 px-3 rounded-full bg-teal-100 text-teal-800 text-sm font-bold uppercase tracking-wider mb-4" data-id="element-21">
              Free Bonus Pack (Value $47)
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-navy-900 mb-6 leading-tight" data-id="element-22">
              If You're Worried You'll Rip It Off at 2am… This Is the Part You
              Need
            </h2>
            <p className="text-lg md:text-xl text-text-body leading-relaxed" data-id="element-23">
              Most people don't quit CPAP because they "don't believe in it."
              They quit because the first few nights feel like a fight they
              can't win.
            </p>
            <div className="mt-6 p-6 bg-white rounded-xl border border-blue-100 shadow-sm text-center" data-id="element-24">
              <p className="font-medium text-navy-800 mb-2" data-id="element-25">
                You don't need motivation. You need a simple, repeatable plan
                for the exact moments that break compliance.
              </p>
              <p className="text-gray-600" data-id="element-26">
                So when you grab{' '}
                <span className="font-bold text-navy-900" data-id="element-27">
                  CPAP Compliance Rescue (Men 65+)
                </span>
                , you also get the{' '}
                <span className="font-bold text-teal-700" data-id="element-28">
                  CPAP Comfort Bonus Pack
                </span>
                —three focused tools that remove the most common reasons men 65+
                abandon therapy in the first 30 nights.
              </p>
            </div>
          </div>
        </FadeIn>

        {/* Bonus 1 */}
        <div className="mb-16 md:mb-24" data-id="element-29">
          <FadeIn delay={100} data-id="element-30">
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100" data-id="element-31">
              {/* Image on top — full bleed, no padding */}
              <div className="w-full" data-id="element-32">
                <img src="https://cdn.magicpatterns.com/uploads/dfPmBeaVyeUoQ4kft4m2c9/BONO_1_CPAP.png" alt="The 2:07 AM Re-Engagement Protocol" className="w-full h-auto block" data-id="element-33" />
              </div>
              {/* Text below */}
              <div className="p-6 sm:p-8 md:p-10" data-id="element-34">
                <div className="flex items-center justify-between mb-4 flex-wrap gap-2" data-id="element-35">
                  <span className="text-amber-600 font-bold tracking-wide uppercase text-sm" data-id="element-36">
                    Bonus #1
                  </span>
                  <span className="bg-gray-100 text-gray-600 px-3 py-1 rounded-full text-xs font-bold uppercase" data-id="element-37">
                    Value: $19 — Yours FREE
                  </span>
                </div>
                <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-navy-900 mb-4 font-serif" data-id="element-38">
                  The 2:07 AM Re‑Engagement Protocol (65+)
                </h3>
                <p className="text-gray-600 mb-6 italic border-l-4 border-teal-600 pl-4" data-id="element-39">
                  "I'm doing fine… until I wake up and rip it off."
                </p>
                <p className="text-gray-700 mb-6" data-id="element-40">
                  This bonus gives you a{' '}
                  <strong data-id="element-41">3‑minute nightstand script</strong> that helps you
                  stop the panic loop before your hands remove the mask.
                </p>
                <ul className="space-y-4" data-id="element-42">
                  <li className="flex items-start" data-id="element-43">
                    <div className="flex-shrink-0 mt-1 mr-4" data-id="element-44">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-45">
                        <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" stroke="#2A7B88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-46" />
                        <path d="M12 9v4l2.5 2.5" stroke="#2A7B88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-47" />
                      </svg>
                    </div>
                    <div data-id="element-48">
                      <span className="font-bold text-navy-900" data-id="element-49">
                        The step‑by‑step "2:07 AM" protocol
                      </span>
                      <p className="text-sm text-gray-600" data-id="element-50">
                        Re-seal quickly without over-tightening.
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-51">
                    <div className="flex-shrink-0 mt-1 mr-4" data-id="element-52">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-53">
                        <rect x="3" y="3" width="18" height="18" rx="2" ry="2" stroke="#2A7B88" strokeWidth="2" data-id="element-54" />
                        <line x1="3" y1="9" x2="21" y2="9" stroke="#2A7B88" strokeWidth="2" data-id="element-55" />
                        <line x1="9" y1="21" x2="9" y2="9" stroke="#2A7B88" strokeWidth="2" data-id="element-56" />
                      </svg>
                    </div>
                    <div data-id="element-57">
                      <span className="font-bold text-navy-900" data-id="element-58">
                        One‑page printable nightstand card
                      </span>
                      <p className="text-sm text-gray-600" data-id="element-59">
                        Keep it by the bed for instant access.
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-60">
                    <div className="flex-shrink-0 mt-1 mr-4" data-id="element-61">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-62">
                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" stroke="#2A7B88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-63" />
                        <polyline points="22 4 12 14.01 9 11.01" stroke="#2A7B88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-64" />
                      </svg>
                    </div>
                    <div data-id="element-65">
                      <span className="font-bold text-navy-900" data-id="element-66">
                        7‑day re‑engagement tracker
                      </span>
                      <p className="text-sm text-gray-600" data-id="element-67">
                        Build a streak of fast re-engagement instead of
                        quitting.
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </FadeIn>
        </div>

        {/* Bonus 2 */}
        <div className="mb-16 md:mb-24" data-id="element-68">
          <FadeIn delay={200} data-id="element-69">
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100" data-id="element-70">
              {/* Image on top — full bleed, no padding */}
              <div className="w-full" data-id="element-71">
                <img src="https://cdn.magicpatterns.com/uploads/3PhaFCJjwk5oNnyHBUypeM/bono_2_cpap_.png" alt="Leak-to-Dry-Mouth Decoder" className="w-full h-auto block" data-id="element-72" />
              </div>
              {/* Text below */}
              <div className="p-6 sm:p-8 md:p-10" data-id="element-73">
                <div className="flex items-center justify-between mb-4 flex-wrap gap-2" data-id="element-74">
                  <span className="text-amber-600 font-bold tracking-wide uppercase text-sm" data-id="element-75">
                    Bonus #2
                  </span>
                  <span className="bg-gray-100 text-gray-600 px-3 py-1 rounded-full text-xs font-bold uppercase" data-id="element-76">
                    Value: $17 — Yours FREE
                  </span>
                </div>
                <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-navy-900 mb-4 font-serif" data-id="element-77">
                  Leak‑to‑Dry‑Mouth Decoder (Beard + Mouth Breather Edition)
                </h3>
                <p className="text-gray-600 mb-6 italic border-l-4 border-teal-600 pl-4" data-id="element-78">
                  Dry mouth isn't "just dry mouth." If you guess wrong, you
                  waste nights.
                </p>
                <p className="text-gray-700 mb-6" data-id="element-79">
                  This bonus gives you a{' '}
                  <strong data-id="element-80">90‑second decision path</strong> to figure out the
                  real cause—then pick the minimum effective fix for tonight.
                </p>
                <ul className="space-y-4" data-id="element-81">
                  <li className="flex items-start" data-id="element-82">
                    <div className="flex-shrink-0 mt-1 mr-4" data-id="element-83">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-84">
                        <path d="M9 18l6-6-6-6" stroke="#2A7B88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-85" />
                        <path d="M5 12h14" stroke="#2A7B88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-86" />
                        <circle cx="19" cy="12" r="2" stroke="#2A7B88" strokeWidth="2" data-id="element-87" />
                      </svg>
                    </div>
                    <div data-id="element-88">
                      <span className="font-bold text-navy-900" data-id="element-89">
                        A simple "cause → fix" flow
                      </span>
                      <p className="text-sm text-gray-600" data-id="element-90">
                        Identify mouth leaks vs. beard leaks vs. humidity
                        issues.
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-91">
                    <div className="flex-shrink-0 mt-1 mr-4" data-id="element-92">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-93">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="#2A7B88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-94" />
                        <polyline points="14 2 14 8 20 8" stroke="#2A7B88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-95" />
                        <line x1="16" y1="13" x2="8" y2="13" stroke="#2A7B88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-96" />
                        <line x1="16" y1="17" x2="8" y2="17" stroke="#2A7B88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-97" />
                        <polyline points="10 9 9 9 8 9" stroke="#2A7B88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-98" />
                      </svg>
                    </div>
                    <div data-id="element-99">
                      <span className="font-bold text-navy-900" data-id="element-100">
                        Printable tracking sheets
                      </span>
                      <p className="text-sm text-gray-600" data-id="element-101">
                        Track dryness, leaks, nasal blockage, and rainout.
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-102">
                    <div className="flex-shrink-0 mt-1 mr-4" data-id="element-103">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-104">
                        <circle cx="12" cy="12" r="10" stroke="#2A7B88" strokeWidth="2" data-id="element-105" />
                        <path d="M12 6v6l4 2" stroke="#2A7B88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-106" />
                      </svg>
                    </div>
                    <div data-id="element-107">
                      <span className="font-bold text-navy-900" data-id="element-108">
                        "Humidity vs Rainout" dial sheet
                      </span>
                      <p className="text-sm text-gray-600" data-id="element-109">
                        Stop over-adjusting and guessing.
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </FadeIn>
        </div>

        {/* Bonus 3 */}
        <div className="mb-16 md:mb-24" data-id="element-110">
          <FadeIn delay={300} data-id="element-111">
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100" data-id="element-112">
              {/* Image on top — full bleed, no padding */}
              <div className="w-full" data-id="element-113">
                <img src="https://cdn.magicpatterns.com/uploads/ucwmydf3E1eQ2cm5oNyWYp/bono_3_CPAP_.png" alt="Doctor-Ready CPAP Visit Pack" className="w-full h-auto block" data-id="element-114" />
              </div>
              {/* Text below */}
              <div className="p-6 sm:p-8 md:p-10" data-id="element-115">
                <div className="flex items-center justify-between mb-4 flex-wrap gap-2" data-id="element-116">
                  <span className="text-amber-600 font-bold tracking-wide uppercase text-sm" data-id="element-117">
                    Bonus #3
                  </span>
                  <span className="bg-gray-100 text-gray-600 px-3 py-1 rounded-full text-xs font-bold uppercase" data-id="element-118">
                    Value: $11 — Yours FREE
                  </span>
                </div>
                <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-navy-900 mb-4 font-serif" data-id="element-119">
                  Doctor‑Ready CPAP Visit Pack (Bring This to Your Provider)
                </h3>
                <p className="text-gray-600 mb-6 italic border-l-4 border-teal-600 pl-4" data-id="element-120">
                  Don't leave your appointment with the same generic advice.
                </p>
                <p className="text-gray-700 mb-6" data-id="element-121">
                  This bonus helps you walk in like the prepared patient who
                  gets taken seriously.
                </p>
                <ul className="space-y-4" data-id="element-122">
                  <li className="flex items-start" data-id="element-123">
                    <div className="flex-shrink-0 mt-1 mr-4" data-id="element-124">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-125">
                        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" stroke="#2A7B88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-126" />
                      </svg>
                    </div>
                    <div data-id="element-127">
                      <span className="font-bold text-navy-900" data-id="element-128">
                        A 60‑second script
                      </span>
                      <p className="text-sm text-gray-600" data-id="element-129">
                        Exactly what to say first so they listen.
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-130">
                    <div className="flex-shrink-0 mt-1 mr-4" data-id="element-131">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-132">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="#2A7B88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-133" />
                        <polyline points="14 2 14 8 20 8" stroke="#2A7B88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-134" />
                        <line x1="12" y1="18" x2="12" y2="12" stroke="#2A7B88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-135" />
                        <line x1="9" y1="15" x2="15" y2="15" stroke="#2A7B88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-136" />
                      </svg>
                    </div>
                    <div data-id="element-137">
                      <span className="font-bold text-navy-900" data-id="element-138">
                        One‑page symptom summary
                      </span>
                      <p className="text-sm text-gray-600" data-id="element-139">
                        Printable summary so you don't forget details.
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-140">
                    <div className="flex-shrink-0 mt-1 mr-4" data-id="element-141">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-142">
                        <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" stroke="#2A7B88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-143" />
                        <rect x="8" y="2" width="8" height="4" rx="1" ry="1" stroke="#2A7B88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-144" />
                        <path d="M9 14l2 2 4-4" stroke="#2A7B88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-145" />
                      </svg>
                    </div>
                    <div data-id="element-146">
                      <span className="font-bold text-navy-900" data-id="element-147">
                        Question checklist & evidence log
                      </span>
                      <p className="text-sm text-gray-600" data-id="element-148">
                        Leave with a real plan, not just generic advice.
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </FadeIn>
        </div>

        {/* Value Stack & CTA */}
        <FadeIn delay={400} data-id="element-149">
          <div className="bg-navy-900 rounded-2xl p-8 md:p-12 text-center text-white shadow-2xl relative overflow-hidden" data-id="element-150">
            <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-151">
              <div className="absolute -top-24 -right-24 w-64 h-64 rounded-full bg-teal-500 blur-3xl" data-id="element-152"></div>
              <div className="absolute -bottom-24 -left-24 w-64 h-64 rounded-full bg-blue-500 blur-3xl" data-id="element-153"></div>
            </div>

            <div className="relative z-10 max-w-3xl mx-auto" data-id="element-154">
              <h3 className="text-2xl md:text-3xl font-bold mb-8" data-id="element-155">
                To recap, when you get CPAP Compliance Rescue (Men 65+), you
                also get:
              </h3>

              <div className="space-y-4 mb-10 text-left max-w-xl mx-auto" data-id="element-156">
                <div className="flex items-center justify-between border-b border-navy-700 pb-3" data-id="element-157">
                  <span className="text-blue-100" data-id="element-158">
                    BONUS #1: The 2:07 AM Re‑Engagement Protocol
                  </span>
                  <span className="font-bold text-amber-500" data-id="element-159">$19 value</span>
                </div>
                <div className="flex items-center justify-between border-b border-navy-700 pb-3" data-id="element-160">
                  <span className="text-blue-100" data-id="element-161">
                    BONUS #2: Leak‑to‑Dry‑Mouth Decoder
                  </span>
                  <span className="font-bold text-amber-500" data-id="element-162">$17 value</span>
                </div>
                <div className="flex items-center justify-between border-b border-navy-700 pb-3" data-id="element-163">
                  <span className="text-blue-100" data-id="element-164">
                    BONUS #3: Doctor‑Ready CPAP Visit Pack
                  </span>
                  <span className="font-bold text-amber-500" data-id="element-165">$11 value</span>
                </div>
                <div className="flex items-center justify-between pt-2 text-xl" data-id="element-166">
                  <span className="font-bold text-white" data-id="element-167">
                    Total Bonus Value:
                  </span>
                  <span className="font-bold text-white" data-id="element-168">
                    <span className="line-through text-gray-500 mr-3" data-id="element-169">$47</span>{' '}
                    FREE
                  </span>
                </div>
              </div>

              <div className="bg-navy-800/50 rounded-lg p-4 mb-8 border border-navy-700 inline-block" data-id="element-170">
                <p className="text-sm text-blue-200" data-id="element-171">
                  <span className="text-amber-500 font-bold mr-2" data-id="element-172">NOTE:</span>
                  These bonuses are included during this launch window so you
                  can stabilize your first 30 nights faster.
                </p>
              </div>

              <div className="block" data-id="element-173">
                <a href="#pricing" onClick={e => {
                e.preventDefault();
                const el = document.getElementById('pricing');
                if (el) {
                  const start = window.scrollY;
                  const end = el.getBoundingClientRect().top + window.scrollY - 20;
                  const duration = 1500;
                  let startTime: number | null = null;
                  const easeInOutCubic = (t: number) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
                  const animate = (currentTime: number) => {
                    if (!startTime) startTime = currentTime;
                    const elapsed = currentTime - startTime;
                    const progress = Math.min(elapsed / duration, 1);
                    window.scrollTo(0, start + (end - start) * easeInOutCubic(progress));
                    if (progress < 1) requestAnimationFrame(animate);
                  };
                  requestAnimationFrame(animate);
                }
              }} className="w-full md:w-auto inline-flex items-center justify-center bg-amber-500 hover:bg-amber-600 text-white text-xl font-bold py-4 px-8 rounded-lg shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200" data-id="element-174">
                  Get CPAP Compliance Rescue + Free Bonus Pack
                  <ArrowRight className="ml-2 h-6 w-6" data-id="element-175" />
                </a>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}